import axios from 'axios';

const FALLBACK = 'Too many attempts. Please wait a while and try again.';

const tooManyAttemptsMessage = (error: unknown): string | null => {
  if (!axios.isAxiosError(error) || error.response?.status !== 429) return null;
  const message = (error.response.data as { errors?: { message?: unknown }[] } | undefined)?.errors?.[0]?.message;
  return typeof message === 'string' && message.trim() ? message : FALLBACK;
};

export default tooManyAttemptsMessage;
